// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn[data-v-f5f8a73a]{height:30px}.login-btn[data-v-f5f8a73a]{border-color:#000}.btn-text[data-v-f5f8a73a]{font-size:16px;font-weight:500 !important;padding:0 16px;color:#000}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
